import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import useTranslation from "../i18n/useTranslation";

const WarningDialog = ({ header, message, visible, onHide, onConfirm, loading }) => {
   const { t } = useTranslation();

   const footer = (
      <div className="flex justify-content-end gap-2 mt-4">
         <Button onClick={onHide} label={t("common.actions.cancel")} severity="secondary" />
         <Button onClick={onConfirm} loading={loading} label={t("copySchedule.confirmContinue")} className="mr-0" />
      </div>
   );

   return (
      <Dialog
         header={header}
         visible={visible}
         onHide={onHide}
         className="warning-dialog"
         footer={footer}
         modal
         closable={false}
         style={{ maxWidth: "640px" }}
         pt={{
            content: {
               className: "px-4 pt-0 pb-1"
            },
         }}
      >
         <div className="bg-soft-pink border-round-md border-pink border-solid border-1 p-4">
            <div className="warning-title font-bold color-pink flex align-items-center mb-3">
               <i className="pi pi-exclamation-triangle mr-3 text-xl"></i>
               {t("common.warning")}
            </div>
            <div className="warning-text color-pink" dangerouslySetInnerHTML={{ __html: message }}></div>
         </div>
      </Dialog>
   );
};

export default WarningDialog;
